import ReactModel from './ReactModel'

class Stop extends ReactModel<BookingStopData> {
    constructor(data: Partial<BookingStopData> = {}) {
        super({
            city: "",
            postal_code: "",
            street: "",
            province: "",
            place_name: "",
            country: "",
            ...data,
        });
    }
}
interface Stop extends BookingStopData {}

export interface BookingStopData {
    city: string
    id: NullablePhpId
    // key: string
    place_name: string
    postal_code: string
    province: string
    street: string
    /** 2-letter country code */
    country: string
}

export default Stop
